import { AuthService } from './../services/auth.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import * as _ from 'lodash';

@Injectable({
    providedIn: 'root'
})
export class aspAuthenticationGuardService  {

    private userRoles: string[] = [];
    /**
     * constructor()
     */
    constructor(private service: AuthService, private router: Router) {
        service.getEmployeeRoles().subscribe(t => {
            this.userRoles = t
        });
    }

    /**
     * canActivate()
     */
    public canActivate(
        route: ActivatedRouteSnapshot,
    ): boolean | UrlTree {
        return this._isAuthenticated(route);
    }

    /**
     * canActivateChild()
     */
    public canActivateChild(
        route: ActivatedRouteSnapshot,
    ): boolean | UrlTree {
        return this._isAuthenticated(route);
    }

    private _isAuthenticated(routeSnapshot: ActivatedRouteSnapshot): boolean | UrlTree {
        const requiredRoles: string[] = Array.isArray(routeSnapshot.data?.roles) ? routeSnapshot.data.roles : [];
        let authorized: boolean;
        if (routeSnapshot.data?.roleCheck === 'OR') {
            authorized = requiredRoles?.some(role => this.userRoles.includes(role));
        } else {
            authorized = requiredRoles?.every(role => this.userRoles.includes(role));
        }
        if (authorized) {
            return true;
        }
        return this.router.parseUrl('/asp/not-authorized');
    }
}
